<template>
  <component
    :is="bannerComponent"
    @click="handleOnUpgradeButtonClick"
    :title="title || defaultTitle"
    :description="description"
  />
</template>

<script>
import { TIER } from '@/constants/price';
import upgradePopup from '@/mixins/upgradePopup';
import {
  TUpgradeBannerLarge,
  TUpgradeBannerSmall,
} from './styled';

const VARIANTS = {
  LARGE: 'large',
  SMALL: 'small',
};

export default {
  name: 'TUpgradeBanner',
  mixins: [
    upgradePopup,
  ],
  props: {
    variant: {
      type: String,
      default: VARIANTS.LARGE,
      validator(value) {
        return Object.values(VARIANTS).includes(value);
      },
    },
    tierKeyToUpgrade: {
      type: String,
      default: TIER.PRO,
      validator(value) {
        return Object.values(TIER).includes(value);
      },
    },
    title: {
      type: String,
      default: null,
    },
    description: {
      type: String,
      default: 'Upgrade your account to unlock this',
    },
  },
  computed: {
    bannerComponent() {
      return this.variant === VARIANTS.LARGE ? TUpgradeBannerLarge : TUpgradeBannerSmall;
    },
    defaultTitle() {
      return `This is a ${this.tierKeyToUpgrade} feature`;
    },
  },
  methods: {
    handleOnUpgradeButtonClick() {
      this.openUpgradePopup(this.tierKeyToUpgrade);
    },
  },
};
</script>
